import { API_LOGIN, API_KEY, API_AUTH_LOGIN } from '../../enums';
import { RECAPTCHA_TOKEN_FIELD } from '../../enums';
import http from '../../http';
//import axios from 'axios';
//import jwt_decode from "jwt-decode";

export const login = async (loginForm, recaptchaResult) => {
  let params = {
    api: API_KEY,
    username: loginForm.login_email,
    password: loginForm.login_password,
    [RECAPTCHA_TOKEN_FIELD]: recaptchaResult
  }

  // const result = await axios({
  //   method: 'POST',
  //   url: API_AUTH_LOGIN,
  //   data: params
  // }).catch((error) => {
  //   throw error;
  // });

  const result = await http.post(API_AUTH_LOGIN, params);

  // const result = await httpPost()({
  //   url: API_AUTH_LOGIN,
  //   data: params
  // }).catch((error) => {
  //   throw error;
  // });

  if (result.data) {
    const {token} = result.data;
    const { data: {user: {data: {id}}}} = result;
    
    // const decodedToken = jwt_decode(token);
    // const decodedTokenHeader = jwt_decode(token, {header: true});
    
    //the auth login part was ok so use the returned token to get the user
    const url = `${API_LOGIN(id)}?api=${API_KEY}&token=${token}&withs=profiles`;

    // const userResult = await axios.get(url).catch((error) => {
    //   console.log(error);
    //   throw error;
    // });

    const userResult = await http.get(url).catch((error) => {
      console.log(error);
      throw error;
    });

    return {...userResult, token};
  }
}